import logoSvgString from "./logo.svg?raw";

export default function Logo() {
  // biome-ignore lint/security/noDangerouslySetInnerHtml: very dangerous
  return <div className="logo-container animated" dangerouslySetInnerHTML={{ __html: logoSvgString }} />;
}
